import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { DialogActions, Button, FormControl, InputLabel, Select, MenuItem, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Info from 'components/utils/Alert/Info';
import { useTranslation } from 'react-i18next';

function RefundTypePopup({
  closeDialog,
  handleRefundType,
  subject,
  hidePaymentModeSelection = false,
  paymentModes = [],
}) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  const [selectedPaymentMode, setSelectedPaymentMode] = useState(() => {
    if (!paymentModes || paymentModes.length === 0) return null;
    return paymentModes.find((m) => m?.name?.toLowerCase() === 'cash') || paymentModes[0];
  });
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (paymentModes && paymentModes.length > 0 && !selectedPaymentMode) {
      const cashMode = paymentModes.find((m) => m?.name?.toLowerCase() === 'cash');
      setSelectedPaymentMode(cashMode || paymentModes[0]);
    }
  }, [paymentModes, selectedPaymentMode]);

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{tPopup('Select payment refund type')}</h2>
          <IconButton onClick={closeDialog} size="small" disabled={isProcessing}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className={styles.inputSec}>
          <h3 className={styles.inputSubLabel}>
            <Info
              title={tPopup('Payment Return Type')}
              content={tPopup(
                'How would you like to process the paid amount in this {{subject}}? You can choose between refunding the payment or keeping it in credit.',
                { subject }
              )}
              severity={'info'}
            />
          </h3>

          {!hidePaymentModeSelection && paymentModes && paymentModes.length > 0 && (
            <FormControl fullWidth variant="outlined" size="small" sx={{ mt: 2, mb: 1 }}>
              <InputLabel id="refund-method-label">{tPopup('Refund Method') || 'Refund Method'}</InputLabel>
              <Select
                labelId="refund-method-label"
                id="refund-method-select"
                value={(selectedPaymentMode?.id ?? selectedPaymentMode?.mode_id) ?? ''}
                disabled={isProcessing}
                label={tPopup('Refund Method') || 'Refund Method'}
                onChange={(e) => {
                  const mode = paymentModes.find((m) => (m?.id ?? m?.mode_id) === e.target.value);
                  setSelectedPaymentMode(mode || null);
                }}
              >
                {paymentModes.map((mode) => {
                  const modeId = mode?.id ?? mode?.mode_id;
                  return (
                    <MenuItem key={modeId} value={modeId}>
                      {mode.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          )}
        </div>
        <div className={styles.footSec}>
          <DialogActions>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              disabled={isProcessing}
              onClick={async () => {
                if (isProcessing) return;
                setIsProcessing(true);
                try {
                  await handleRefundType('refund', selectedPaymentMode);
                } catch (err) {
                  setIsProcessing(false);
                }
              }}
              className={styles.closeBtn}
            >
              {isProcessing ? tCommon('Processing...') : tCommon('Refunded')}
            </Button>
            <Button
              variant="contained"
              size="small"
              disabled={isProcessing}
              sx={{ bgcolor: isProcessing ? undefined : '#00a65a' }}
              onClick={async () => {
                if (isProcessing) return;
                setIsProcessing(true);
                try {
                  await handleRefundType('credit');
                } catch (err) {
                  setIsProcessing(false);
                }
              }}
            >
              {isProcessing ? tCommon('Processing...') : tCommon('Keep In Credit')}
            </Button>
          </DialogActions>
        </div>
      </div>
    </div>
  );
}

export default RefundTypePopup;
